import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const AnalyticsView = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/analytics`);
        setData(res.data);
      } catch (err) {
        console.error("Error fetching analytics", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAnalytics();
  }, []);

  return (
    <div>
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ margin: 0, color: "#fff" }}>Platform Analytics & Volume Reports</h2>
        <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
          Platform metrics, active trading clients, daily trading volume, and most popular stock symbols
        </p>
      </div>

      {loading ? (
        <div style={{ padding: "20px", color: "#888" }}>Calculating platform analytics...</div>
      ) : (
        <div>
          {/* Summary Metric Cards */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "24px" }}>
            <div style={cardStyle}>
              <div style={cardLabelStyle}>Total Platform Clients</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#2962ff", marginTop: "6px" }}>
                {data?.totalClients || 0}
              </div>
            </div>

            <div style={cardStyle}>
              <div style={cardLabelStyle}>Active Clients</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#4caf50", marginTop: "6px" }}>
                {data?.activeClients || 0}
              </div>
            </div>

            <div style={cardStyle}>
              <div style={cardLabelStyle}>Trades Today</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#ff9800", marginTop: "6px" }}>
                {data?.tradesToday || 0}
              </div>
            </div>

            <div style={cardStyle}>
              <div style={cardLabelStyle}>Total Trade Volume</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#ab47bc", marginTop: "6px" }}>
                ₹{data?.totalVolume?.toLocaleString('en-IN', { maximumFractionDigits: 2 }) || "0.00"}
              </div>
            </div>
          </div>

          {/* Top Symbols Breakdown */}
          <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", padding: "20px", border: "1px solid #2a2e39" }}>
            <h3 style={{ margin: "0 0 16px 0", color: "#fff", fontSize: "16px" }}>Most Traded Stock Symbols (Volume Distribution)</h3>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "12px" }}>
              {Object.entries(data?.symbolCounts || {}).map(([sym, qty]) => (
                <div key={sym} style={{ backgroundColor: "#2a2e39", padding: "14px", borderRadius: "6px", border: "1px solid #363c4e" }}>
                  <div style={{ fontWeight: "bold", fontSize: "16px", color: "#4184f3" }}>{sym}</div>
                  <div style={{ fontSize: "13px", color: "#b2b5be", marginTop: "4px" }}>Total Traded Qty: <strong>{qty}</strong></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const cardStyle = {
  backgroundColor: "#1e222d",
  padding: "18px",
  borderRadius: "8px",
  border: "1px solid #2a2e39",
};

const cardLabelStyle = {
  fontSize: "12px",
  color: "#b2b5be",
  textTransform: "uppercase",
};

export default AnalyticsView;
